import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";
import BarPositiveAndNegative from "components/visuals/BarPositiveAndNegative";

import { selectors } from "modules/customer/insights/portfolio/catchment/demographicBreakdown";

const HouseholdCompIndex = () => {
    const householdCompIndex = useSelector(state => selectors.householdCompIndex(state));
    const { loading, error, categories, values } = householdCompIndex;
    
    const options = {
        title: {
            text: "Household composition"
        },
        xAxis: [
            { categories: categories },
            {}
        ],
        series: [{
            data: values
        }]
    };

    return (
        <Box data-cy="household-comp-index">
            <BarPositiveAndNegative loading={loading} error={error} options={options} />
        </Box>
    );
};

export default HouseholdCompIndex;
